export default {
  Model: {},
  Actions: {
    GET_BA_INFO_SUCCESS: 'BaInfo/GET_BA_INFO_SUCCESS',
    CREATE_BA_SUCCESS: 'BaInfo/CREATE_BA_SUCCESS',
  },
  State: {
    BA_INFO_BY_USER_SLUG: 'BA_INFO_BY_USER_SLUG',
    PENDING_BA_ASSESSMENT_ID_BY_USER_SLUG: 'PENDING_BA_ASSESSMENT_ID_BY_USER_SLUG',
  },
};
